import { MonoTypeOperatorFunction, race, timer, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export class TimeoutHelper {
	public static AckTimeout = 20000;
	public static ExecutionTimeout = 600000;

	public static AckFailMessage = 'Connection to server lost. Please refresh your browser window. Contact your administrator if the problem persists.';
}

export function raceTimeout<T>(due: number | Date, text: string): MonoTypeOperatorFunction<T> {
	return obs$ => race(obs$, timer(due).pipe(switchMap(() => throwError(() => text))));
}

export function ackTimeout<T>(due: number | Date, text: string): MonoTypeOperatorFunction<T> {
	return obs$ => obs$.pipe(raceTimeout(TimeoutHelper.AckTimeout, TimeoutHelper.AckFailMessage));
}
